export const IP_REGEXP = /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/

export const COLOR_REGEXP = /^#[0-9A-Fa-f]{6}$/

export const NAME_REGEXP = /^[a-z0-9_]+$/

export const URL_REGEXP = /^(ftp|http|https):\/\/[^ "]+$/
